enum SlaNoteTargetType {
  CONTACT = 'CONTACT',
  VEHICLE = 'OBJECT',
}

export default SlaNoteTargetType;